import { render, staticRenderFns } from "./almacenarInventario.vue?vue&type=template&id=6207514d&"
import script from "./almacenarInventario.vue?vue&type=script&lang=js&"
export * from "./almacenarInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports